// ── Shared rep profile store — syncs rep profile data between admin & rep portals ──
// When admin edits a rep's info (name, phone, territory, etc.) it shows in rep portal.
// When rep edits their own profile, it shows in admin control panel.
// Uses localStorage + pub/sub so both portals see the same profile data in real-time.

const LS_KEY = "mpcare_shared_rep_profiles";

function load() {
  try { const raw = localStorage.getItem(LS_KEY); if (raw) return JSON.parse(raw); } catch (e) {}
  return {};
}

function save(profiles) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(profiles)); } catch (e) {}
}

const SHARED_REP_PROFILES = {
  _profiles: load(),   // keyed by rep userId or email
  _subs: [],

  /** Get profile for a rep by their ID (Supabase user id or email) */
  get(repKey) {
    return this._profiles[repKey] || null;
  },

  /** Get all rep profiles */
  getAll() {
    return { ...this._profiles };
  },

  /** Set/update a rep's profile (called from either portal) */
  set(repKey, data) {
    this._profiles[repKey] = {
      ...(this._profiles[repKey] || {}),
      ...data,
      updatedAt: new Date().toISOString()
    };
    save(this._profiles);
    this._notify();
  },

  /** Permanently remove a rep (admin delete). Also removes alias keys (email) if provided. */
  delete(...keys) {
    let changed = false;
    keys.forEach(k => { if (k && this._profiles[k]) { delete this._profiles[k]; changed = true; } });
    if (changed) { save(this._profiles); this._notify(); }
  },

  /** Subscribe to changes */
  subscribe(fn) {
    this._subs.push(fn);
    return () => { this._subs = this._subs.filter(f => f !== fn); };
  },

  _notify() {
    const profiles = { ...this._profiles };
    this._subs.forEach(fn => { try { fn(profiles); } catch (e) {} });
  }
};

export default SHARED_REP_PROFILES;
